import React from 'react';

// Icône Humidité (goutte avec % à l'intérieur)
const HumidityIcon = ({ sx }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    style={sx}
  >
    {/* Goutte */}
    <path d="M12 2C12 2 5 10 5 15.5C5 19.09 8.13 22 12 22C15.87 22 19 19.09 19 15.5C19 10 12 2 12 2Z" />
    
    {/* Signe % au centre */}
    <text
      x="50%"
      y="55%"
      textAnchor="middle"
      dominantBaseline="middle"
      fontSize="8"
      fill="white"
      fontWeight="bold"
    >
      %
    </text>
  </svg>
);

export default HumidityIcon;
